import React, { useEffect, useState, useReducer } from "react";
import Loading from "components/common/Loading";
const initialState = { isPending: false, isFulfilled: false, isRejected: false };

const PENDING_ACTION = "pending";
const FULLFILLED_ACTION = "fulfilled";
const REJECTED_ACTION = "rejected";

const reducer = (state, action) => {
    switch (action.type) {
        case PENDING_ACTION:
            return { isPending: true, isFulfilled: false, isRejected: false };
        case FULLFILLED_ACTION:
            return { isPending: false, isFulfilled: true, isRejected: false };
        case REJECTED_ACTION:
            return { isPending: false, isFulfilled: false, isRejected: true };
        default:
            throw new Error();
    }
};
//로딩 상태 관리 유틸
//Author 19001814
/* -- State
   isPending :true or false
   isFulfilled :true or false
   isRejected :true or false
   -- Method
   setPending()    수행중
   setFullfilled() 완료
   setRejected()   실패
   PendigProgress() : pending 중이면 progressbar 생성 (Cutomizing에 대한 추후 고려 필요)
   isFulfilled : getter isFulfilled
   isRejected  : getter isRejected
    */
const PenderManager = () => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const setPending = () => {
        dispatch({ type: PENDING_ACTION });
    };

    const setFullfilled = () => {
        dispatch({ type: FULLFILLED_ACTION });
    };

    const setRejected = () => {
        dispatch({ type: REJECTED_ACTION });
    };
    //Progress 컴포넌트 출력 부분
    const PendigProgress = () => {
        return (
            state.isPending && (
                <></>
                // <div style={{ justifyContent: "center", textAlign: "center" }}>
                //     <CircularProgress color="secondary" size={100} />
                // </div>
                //<Loading />
            )
        );
    };

    const getFulfilled = () => {
        return state.isFulfilled;
    };

    const getRejected = () => {
        return state.isRejected;
    };

    return [PendigProgress, getFulfilled, setPending, setFullfilled, getRejected, setRejected, state];
};

export default PenderManager;
